var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3 col-xs-6 p-3 highlight zoomdiv text-center",on:{"click":function($event){_vm.navigate(_vm.data)}}},[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":require(("../assets/thumbs/" + (_vm.data.iconSrc)))}}),_vm._v(" "),_c('h5',{staticClass:"mt-2 text-capitalize"},[_vm._v(_vm._s(_vm.data.gameName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef9ca636","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameItem.vue
// module id = 31
// module chunks = 0